"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactTimeoutButtonOverlay = void 0;

var core_1 = require("@emotion/core");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = __importDefault(require("react"));

var ltrKeyframes = core_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    left: 0;\n  }\n  100% {\n    left: 100%;\n  }\n"], ["\n  0% {\n    left: 0;\n  }\n  100% {\n    left: 100%;\n  }\n"])));
var rtlKeyframes = core_1.keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  0% {\n    right: 0;\n  }\n  100% {\n    right: 100%;\n  }\n"], ["\n  0% {\n    right: 0;\n  }\n  100% {\n    right: 100%;\n  }\n"])));
var Wrapper = styled_1.default.span(function (_a) {
  var timeout = _a.timeout,
      paused = _a.paused,
      color = _a.color,
      opacity = _a.opacity,
      rtl = _a.rtl;
  return {
    animation: (rtl ? rtlKeyframes : ltrKeyframes) + " " + timeout / 1000 + "s linear 1",
    animationFillMode: 'forwards',
    animationPlayState: paused ? 'paused' : 'initial',
    background: color,
    bottom: 0,
    left: 0,
    opacity: opacity,
    position: 'absolute',
    right: 0,
    top: 0
  };
});

exports.ReactTimeoutButtonOverlay = function (props) {
  return react_1.default.createElement(Wrapper, __assign({}, props));
};

exports.ReactTimeoutButtonOverlay.defaultProps = {
  color: '#000000',
  opacity: 0.15
};
var templateObject_1, templateObject_2;